import { render, staticRenderFns } from "./MultiBookingAdmin.vue?vue&type=template&id=6345c3f8&"
import script from "./MultiBookingAdmin.vue?vue&type=script&lang=js&"
export * from "./MultiBookingAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MultiBookingAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports